module.exports = __webpack_public_path__ + "media/abk/assets/images/logo-998e5f64e4716418e369ecc0655343c8.svg";